// API client = adapter + a thin retry/error layer. All controllers and pages
// import from here; they never touch the adapters directly.

import { config } from "../config";
import { embeddedAdapter } from "./adapter.embedded";
import { restAdapter } from "./adapter.rest";

export const api = config.isEmbedded ? embeddedAdapter : restAdapter;
